<template>
  <TemplateModal
    :text="{
      button: {
        open: localStorage.translations.pages['sales_project']['planned_resources-subscribers']
          .add_project,
        create: localStorage.translations.pages.common.buttons['sohranit'],
      },
      title: {
        create:
          localStorage.translations.pages['sales_project']['planned_resources-subscribers']
            .add_project,
      },
    }"
    ref="modal"
    center
    width="750"
    :sendFunction="onSubscriberCreateOrUpdate"
  >
    <div class="send">
      <BaseInput
        v-model="user_id"
        :label="
          localStorage.translations.pages['sales_project']['planned_resources-subscribers']
            .subscriber
        "
        type="autocomplete"
        :items="commonUserSubscribersAll"
        :item-text="(i) => i.first_name + ' ' + i.last_name"
        :rules="['required']"
      />
      <BaseInput
        v-model="projects_subscriptions"
        :label="localStorage.translations.pages.planning_orders.table.proekt"
        type="autocomplete"
        :items="projectsReady"
        multiple
        chips
        deletable-chips
        :rules="['required']"
        :disabled="!user_id"
      />
    </div>
  </TemplateModal>
</template>

<script>
// import UsersListItem from 'components/setting/users/UsersListItem'
import TemplateModal from 'components/templates/TemplateModal'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SettingsSubscribersModal',
  props: {
    onDownloadPageData: Function,
    itemData: Object,
  },
  components: {
    TemplateModal,
  },
  data: () => ({
    projects_subscriptions: null,
    user_id: null,
  }),
  created() {},
  watch: {
    '$refs.modal.dialog'() {
      if (this.$refs.modal && this.$refs.modal.dialog) {
        this.onCommonUserSubscribersAll()
        this.onWorkClientProjectGrid_filter({
          limit: 0,
          page: 1,
          filter: {status: 'in_progress,done'},
        })
        if (this.itemData) {
          this.user_id = this.itemData.user.id
          this.project_id = this.itemData.project.id
        }
      }
    },
    user_id() {
      this.project_id = null
    },
  },
  computed: {
    ...mapGetters('commonUser', ['commonUserSubscribersAll']),
    ...mapGetters('workClientProject', ['workClientProjectGrid_filter']),
    projectsReady() {
      let result = this.workClientProjectGrid_filter
      if (this.user_id) {
        if (this.usedProjectsIds.length) {
          result = this.workClientProjectGrid_filter.filter((i) =>
            this.usedProjectsIds.includes(i.id) ? false : true,
          )
        }
      }
      return result
    },
    selectUserData() {
      if (this.user_id) {
        return this.commonUserSubscribersAll.find((i) => i.id === this.user_id)
      } else return null
    },
    usedProjectsIds() {
      if (this.user_id) {
        return this.selectUserData.projects_subscriptions.map((i) => i.project_id)
      } else return []
    },
  },
  methods: {
    ...mapActions('commonUser', ['onCommonUserSubscribersAll']),
    ...mapActions('workClientProject', ['onWorkClientProjectGrid_filter']),
    ...mapActions('workClientProjectsSubscribers', [
      'onWorkClientProjectsSubscribersCreate',
      'onWorkClientProjectsSubscribersUpdate',
    ]),
    ...mapActions('commonUser', ['onCommonUserUpdate']),
    onClearData() {
      this.user_id = null
      this.projects_subscriptions = null
    },
    async onSubscriberCreateOrUpdate() {
      if (this.$refs.modal.validate()) {
        let data = {
          id: this.user_id,
          projects_subscriptions: [...this.usedProjectsIds, ...this.projects_subscriptions],
          first_name: this.selectUserData.first_name,
          last_name: this.selectUserData.last_name,
        }
        this.onCommonUserUpdate(data)
          .then(() => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['sent_successfully'],
                IsError: false,
              },

              { root: true },
            )
            this.$refs.modal.closeModal()
            this.onDownloadPageData()
            this.onClearData()
          })
          .catch(() => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.send {
  width: 100%;
  display: grid;
  row-gap: 10px;
}
</style>
